import React from 'react';
import { useSelector } from 'react-redux';
import { Situation } from 'types';
import { SituationsSelectors } from '../../../common/config/store';
import StyledTable from '../../organisms/styled-table';
import ListModifier from '../../organisms/list-modifier';
import { useIntl } from '../../../common/config/i18n';
import { Empty } from 'antd';

type Props = {
  onClickEdit?: (situation: Situation) => void;
  onClickDelete?: (situation: Situation) => void;
  canWrite: boolean;
};

const SituationTable: React.FC<Props> = ({ onClickEdit, onClickDelete, canWrite }: Props) => {
  const { t } = useIntl();
  const data = useSelector(SituationsSelectors.situationsSelector);

  const columns = [
    {
      title: t('table', 'CHART_PROCESS'),
      key: 'situationCategoryID',
      render: (record: { situationCategory: { id: number; name: string } }) => (
        <div>{record?.situationCategory?.name}</div>
      ),
    },
    {
      title: t('table', 'CHART_SITUATION'),
      key: 'name',
      dataIndex: 'name',
    },

    {
      title: t('table', 'COLUMN_EDIT_DELETE'),
      key: 'modifier',
      shouldBeAdmin: true,
      render: (record: Situation) => (
        <ListModifier
          hideEditButton={record.isNotEditable || !canWrite}
          hideDeleteButton={record.isNotEditable || !canWrite}
          onDelete={() => onClickDelete?.(record)}
          onEdit={() => onClickEdit?.(record)}
        />
      ),
    },
  ];

  return (
    <StyledTable
      textAlign="left"
      pagination={false}
      dataSource={data}
      columns={canWrite ? columns : columns.filter((column) => !column.shouldBeAdmin)}
      rowKey="id"
      locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
    />
  );
};

export default SituationTable;
